import React, { useEffect, useState } from 'react'

import { Loader } from '../components/ui-blocks'
import { getConfirmDelete } from '../components/specialized-components'

import { Topics as TopicsComponent } from '../components/Topics'

import { useModal } from '../contexts'

import { getTopics, deleteTopic } from '../helpers/consultdex-wp-api'


export const Topics = () => {
  const [topics, setTopics] = useState()
  const { openModal } = useModal()


  const loadTopics = () => {
    getTopics()
      .then(results => {
        setTopics(results)
      })
  }

  useEffect(loadTopics, [])


  const deleteAction = async row => {
    const isConfirmed = await openModal(
      getConfirmDelete(<>You will delete the topic <strong>{row.title}</strong>.</>)
    )

    if (!isConfirmed) {
      return
    }

    await deleteTopic(row.id)

    loadTopics()
  }


  return (
    <>
      <h1>Topics</h1>
      {!!topics ? (
        <TopicsComponent topics={topics} deleteAction={deleteAction} />
      ) : (
          <Loader fullWidth />
        )}
    </>
  )
}
